<template>
  <!-- Site wrapper -->
  <div class="wrapper">
    <cabecalho tituloPagina="Faturas" />
    <menuLateral />
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <div class="container-fluid"></div>
        <!-- /.container-fluid -->
      </section>
      <!-- Main content -->
      <section class="content">
      <!-- Default box -->
      <div class="card">
        <div class="card-body">
          <spinnerProcessando cssClass="ml-2" :status="flagsDeControle.carregandoDados.status" :mensagem="flagsDeControle.carregandoDados.mensagem"/>
          <default-table
            :items="listaFaturas"
            :fields="fields"
            :striped="false"
            :busy="flagsDeControle.carregandoDados.status"
            :tbody-tr-class="definirClasseLinha">
            <template #empty>
              <em>Nenhum registro encontrado.</em>
            </template>
            <template #cell(data_vencimento)="row">
              {{$date(row.item.data_vencimento).format('DD/MM/YYYY')}}
            </template>
            <template #cell(data_emissao)="row">
              {{$date(row.item.data_emissao).format('DD/MM/YYYY')}}
            </template>
            <template #cell(valor_total)="row">
              {{ formatarValorMonetario(row.item.valor_total) }}
            </template>
            <template #cell(descricao)="row">
              <router-link class="linkr" :to="{ name: 'faturaDetalhes', params: { id: row.item.id } }">{{ obterDescricaoFatura(row.item) }}</router-link>
            </template>
            <template #cell(status)="row">
              <span :class="{'statusPago': row.item.status === 1,
                             'statusPendente': row.item.status === 2 || row.item.status === 4,
                             'statusAberto': row.item.status === 3}">
                {{ obterDescricaoStatusFatura(row.item.status) }}
              </span>
            </template>
            <template #cell(acoes)="row">
              <b-button class="botoes botaoPagamentoFatura" :class="{'botaoFaturaPaga': row.item.status === 1, 'botaoFaturaPendente': row.item.status !== 1}" :disabled="row.item.status === 1" variant="outline-primary btn-sm" @click="encaminharParaPagamento(row.item.id)">Pagar</b-button>
            </template>
          </default-table>
          <pagination :fonteDeDados="componentePaginacao.fonteDeDados" :disabled="flagsDeControle.carregandoDados.status" @navegarNaPaginacao="obterDadosPaginados"/>
        </div>
      </div>
    </section>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
  </div>
  <!-- ./wrapper -->
</template>

<script>
import Faturas from './js'
export default Faturas
</script>

<style scoped>
@import "./scss/faturas.scss";
</style>
